import { COLORS, DSBottomSheet } from '@repo/design-system/index'
import {
  QIcon_check_mark,
  QIcon_chevron_bold_right,
  QIcon_chevron_left,
  QIcon_close_default,
  QIcon_tune,
} from '@repo/icons/index'
import { useState } from 'react'
import { useConversationSetting, useConversationSettingSetSpeed } from '../../../../modules/apis/student/conversation'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useWakeLock from '../../../../modules/hooks/common/useWakeLock'
import useReturnFullUrl from '../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_speaking, n_ai_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { speedsArray } from '../../../../modules/vars'
import { useConversationAIStack } from '../../../../pages/[lang]/webview/conversational-ai'
import RoleplayCompletePopup from './RoleplayCompletePopup'
import RoleplayStopPopup from './RoleplayStopPopup'

const ConversationHeader = ({
  thread,
  title,
  isConversationDone,
  isConversationQualified,
  onClickThreadSummary,
  showCompleteModal,
  setShowCompleteModal,
}) => {
  const [stopModal, setStopModal] = useState(false)
  const { t } = useTranslation()
  const getFullUrl = useReturnFullUrl()
  const { useConversationAIFlow } = useConversationAIStack()
  const { push } = useConversationAIFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })
  const [showSetting, setShowSetting] = useState(false)
  const [showSpeed, setShowSpeed] = useState(false)

  const setting = useConversationSetting()
  const setSpeed = useConversationSettingSetSpeed()

  useWakeLock()

  const routerMoveListPage = () => {
    router.back()
  }

  const onClickExitBtn = () => {
    console.log('onClickExitBtn', isConversationDone, isConversationQualified)
    if (isConversationQualified) {
      // 세션 마무리되었으면 setShowCompleteModal
      setShowCompleteModal(true)
    } else {
      // 세션 마무리 안되었으면 setStopModal
      setStopModal(true)
    }
  }

  const onClickSpeedBtn = (speed) => {
    if (speed == setting?.data?.speed) return
    setSpeed.mutateAsync(speed)
    setShowSpeed(false)
  }

  return (
    <div className="flex w-screen flex-row items-center justify-between py-[12px] pr-[20px]">
      <div
        className="pl-[20px] pr-[20px] flex flex-col justify-center"
        style={{ cursor: 'pointer', height: 48 }}
        onClick={() => {
          if (isConversationDone) {
            routerMoveListPage()
          } else {
            onClickExitBtn()
          }
        }}
      >
        <QIcon_chevron_left width={24} height={24} color={COLORS.BLACK} />
      </div>

      <div className="flex-1 flex flex-row items-center justify-center min-w-[0]">
        {title ? (
          <div className="h-full gap-x-[20px] Body1-16Md w-full truncate">{title}</div>
        ) : (
          <div className="h-full gap-x-[20px] Body1-16M animate-pulse rounded-md bg-gray-100 text-transparent w-full truncate">
            Loading
          </div>
        )}
      </div>
      <QIcon_tune width={24} height={24} color={COLORS.BLACK} onClick={() => setShowSetting((prev) => !prev)} />
      <RoleplayStopPopup
        thread={thread}
        stopModal={stopModal}
        setStopModal={setStopModal}
        minimumWord={thread?.minimum_word}
      />
      <RoleplayCompletePopup
        showCompleteModal={showCompleteModal}
        setShowCompleteModal={setShowCompleteModal}
        onClickThreadSummary={onClickThreadSummary}
      />
      <DSBottomSheet
        id="ConversationSettingBottomSheet"
        isOpen={showSetting}
        setIsOpen={setShowSetting}
        closeButton={false}
        closeOnDim={true}
      >
        <div className="px-[20px] mb-[64px]">
          <div className="flex flex-row justify-between items-center mb-[20px] mt-[10px]">
            <div className="Title2-18Bd ">
              {showSpeed ? t(n_ai_tutor.roleplay_setting.category1) : t(n_ai_speaking.ai_session.setting_txt15)}
            </div>
            <div>
              <QIcon_close_default
                color={COLORS.GRAY500}
                width={24}
                height={24}
                onClick={() => setShowSetting(false)}
              />
            </div>
          </div>
          {showSpeed && <div className="Body2-14Md text-gray-600">{t(n_ai_tutor.roleplay_setting.detail)}</div>}
          {!showSpeed ? (
            <div
              className="my-[15px] flex flex-row items-center justify-between Body1-16Md"
              onClick={() => setShowSpeed(true)}
            >
              <div>{t(n_ai_tutor.roleplay_setting.category1)}</div>
              <div className="flex flex-row items-center gap-[2px] text-gray-600">
                <div>{setting?.data?.speed?.toFixed(1)}</div>
                <QIcon_chevron_bold_right color={COLORS.GRAY500} width={16} height={16} />
              </div>
            </div>
          ) : (
            <div className="flex flex-col mt-[15px]">
              {speedsArray.map((speed, index) => {
                return (
                  <div
                    className="flex flex-row items-center justify-between my-[15px] Body1-16Md"
                    key={index}
                    onClick={() => onClickSpeedBtn(speed)}
                  >
                    <div>{speed?.toFixed(1)}</div>
                    <div>
                      {speed == setting.data.speed && <QIcon_check_mark width={24} height={24} color={COLORS.BLACK} />}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </DSBottomSheet>
    </div>
  )
}

export default ConversationHeader
